export default from './notification-list';



// WEBPACK FOOTER //
// ./app/components/notification-list/index.js